var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.26676 6.66667H3.93343C3.57981 6.66667 3.24067 6.80714 2.99062 7.05719C2.74057 7.30724 2.6001 7.64638 2.6001 8V12.6667C2.6001 13.0203 2.74057 13.3594 2.99062 13.6095C3.24067 13.8595 3.57981 14 3.93343 14H11.9334C12.2871 14 12.6262 13.8595 12.8762 13.6095C13.1263 13.3594 13.2668 13.0203 13.2668 12.6667V8C13.2668 7.64638 13.1263 7.30724 12.8762 7.05719C12.6262 6.80714 12.2871 6.66667 11.9334 6.66667H10.6001M5.26676 6.66667V4.66667C5.26676 3.95942 5.54772 3.28115 6.04781 2.78105C6.54791 2.28095 7.22619 2 7.93343 2C8.64067 2 9.31895 2.28095 9.81905 2.78105C10.3191 3.28115 10.6001 3.95942 10.6001 4.66667V6.66667M5.26676 6.66667H10.6001M7.93343 9.33333V11.3333",
    stroke: "#16192C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.6954e67f5f07c9416e53cafae312fad1.svg";
export { ForwardRef as ReactComponent };